// Sticky-year timeline ([company_timeline], [awards_by_year]): as the year groups pass
// the middle of the viewport, the pinned numeral rolls to that year, the line fills down
// to it, and its chip in the rail is marked. The year chips scroll to their group.
// Without this script (or with reduced motion) every group simply shows at full strength.
(function () {
	var timelines = document.querySelectorAll('.neo-timeline');
	if (!timelines.length) {
		return;
	}

	var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var pad = function (n) {
		return n < 10 ? '0' + n : String(n);
	};

	timelines.forEach(function (timeline) {
		var groups = Array.prototype.slice.call(timeline.querySelectorAll('.neo-timeline__group'));
		var year = timeline.querySelector('.neo-timeline__year span');
		var step = timeline.querySelector('.neo-timeline__step');
		var fill = timeline.querySelector('.neo-timeline__fill');
		var list = timeline.querySelector('.neo-timeline__list');
		var chips = Array.prototype.slice.call(timeline.querySelectorAll('.neo-timeline__rail button'));
		var current = -1;
		var ticking = false;

		if (!groups.length) {
			return;
		}

		timeline.classList.add('is-enhanced');

		chips.forEach(function (chip, i) {
			chip.addEventListener('click', function () {
				groups[i].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
			});
		});

		function roll(index) {
			var label = groups[index].getAttribute('data-year');

			if (step) {
				step.textContent = pad(index + 1);
			}
			if (!year) {
				return;
			}
			if (reduced || current === -1) {
				year.textContent = label;
				return;
			}

			year.classList.add('is-leaving');
			window.setTimeout(function () {
				year.textContent = label;
				year.classList.remove('is-leaving');
				year.classList.add('is-entering');
				window.requestAnimationFrame(function () {
					window.requestAnimationFrame(function () {
						year.classList.remove('is-entering');
					});
				});
			}, 160);
		}

		function update() {
			ticking = false;
			var middle = window.innerHeight / 2;
			var index = 0;

			groups.forEach(function (group, i) {
				if (group.getBoundingClientRect().top < middle) {
					index = i;
				}
			});

			groups.forEach(function (group, i) {
				group.classList.toggle('is-active', i <= index);
			});
			chips.forEach(function (chip, i) {
				chip.classList.toggle('is-current', i === index);
				if (i === index) {
					chip.setAttribute('aria-current', 'true');
				} else {
					chip.removeAttribute('aria-current');
				}
			});

			if (fill && list) {
				var rect = list.getBoundingClientRect();
				fill.style.height = Math.max(0, Math.min(rect.height, middle - rect.top)) + 'px';
			}

			if (index !== current) {
				roll(index);
				current = index;
			}
		}

		function request() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', request, { passive: true });
		window.addEventListener('resize', request);
		update();
	});
})();
